import { ListItemText } from '@mui/material';
import { NavSubListItem } from '@procureai/ui-mui';
import { Link, useMatch } from 'react-router-dom';

export interface SmartLinksNavListItemProps {
  title: string;
  to: { pathname: string };
}

export const SmartLinksNavListItem = ({ title, to }: SmartLinksNavListItemProps) => {
  const selected = !!useMatch({ path: `/:domain/${to.pathname}`, end: true });

  return (
    <NavSubListItem component={Link} to={to} selected={selected}>
      <ListItemText primary={title} />
    </NavSubListItem>
  );
};
